export const device = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  mobileXL: '479px',
  tablet: '768px',
  laptop: '1024px',
  laptopM: '1126px',
  laptopL: '1440px',
  desktop: '2560px',
};
